<template>
  <div class="outlook-auth"></div>
</template>

<script>
export default {
  name: 'outlook-auth',
  mounted () {
    this.$http.get('/outlook-auth').then(response => {
      window.location.href = response.data.authorization_url;
    }).catch((error, response) => {
      console.log('ERR', error, response)
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/OutlookAuth.vue